import { useState, useEffect, useRef } from "react";

export function useRatingEstimation(channelId) {
  const [rating, setRating] = useState(null);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!channelId) return;

    const fetchRating = () => {
      fetch(`https://ratingcoefs.api.adsctv.net/rating-estimate?c=${channelId}`, {
        headers: { Token: localStorage.getItem("adm_panel_token") || "" },
      })
        .then((res) => res.text())
        .then((text) => {
          const num = parseFloat(text);
          if (!isNaN(num)) setRating(num.toFixed(2));
        })
        .catch(() => {});
    };

    fetchRating();
    intervalRef.current = setInterval(fetchRating, 10000);

    return () => clearInterval(intervalRef.current);
  }, [channelId]);

  return rating;
}
